/**
 * Generic empty-state page used for all modules until their real pages land
 * in Prompts 2–8. No invented figures — only guidance about what to enter next.
 */
export default function CmdPlaceholder({ title, hint, testId }) {
  return (
    <section>
      <h1 style={{ margin: "4px 0 20px", fontSize: 28, fontWeight: 700, letterSpacing: "-0.02em" }}>{title}</h1>
      <div className="cmd-empty" data-testid={testId || "cmd-placeholder"}>
        <h3>Nothing to show yet</h3>
        <p>{hint}</p>
      </div>
    </section>
  );
}
